@if (data()?.renderableComponents) {
  @for (
    icon of data().renderableComponents;
    let i = $index;
    track i;
    let isLast = $last
  ) {
    <div [ngStyle]="cssStylesMap.get(i)" [ngClass]="cssClassMap.get(i)"></div>
  }
}
